import { computed } from 'mobx';

export default class LocationTypeModel {
  id;
  store;

  constructor(store, item) {
    this.store = store;
    this.id = +item.id;
    this.name = item.name;
    this.description = item.description;
    this.parent_location = item.parent_location
  }

  @computed get asJson() {
    return {
      id: +this.id,
      name: this.name,
      description: this.description,
      parent_location: this.parent_location,
    };
  }

  updateFromJson(item) {
    this.id = +item.id;
    this.name = item.name;
    this.description = item.description;
    this.parent_location = item.parent_location
  }
}



// WEBPACK FOOTER //
// ./src/models/Location/LocationTypeModel.js